import documentIcon from '../../assets/documentIcon.png';
import { GeneralTexts } from '../../language/Texts';
import { IDocument } from '../../models/IDocument';
import { Utils } from '../../utils/Utils';
import AccordionComponent from '../accordionComponent/AccordionComponent';
import SectionTitle from '../sectionTitle/SectionTitle';

import './ProductDocuments.scss';

interface DocumentProps {
    componentDocuments: IDocument[],
    productDocuments: IDocument[]
}

function ProductDocuments({ componentDocuments, productDocuments }: DocumentProps) {
    let documentList: IDocument[] = [
        ...productDocuments,
        ...componentDocuments
    ].filter((document) => {
        return document.link && document.title && document.mimeType;
    });
    documentList = documentList.map((document) => {
        return {
            ...document,
            title: Utils.addExtensionIfMissing(document.title, document.mimeType),
        }
    });

    const componentBody =
        <div className="document_list">
            {documentList?.map((document, index) => {
                return (
                    <a
                        key={index}
                        className="doc_link"
                        href={document.link}
                        rel="noreferrer"
                        type={document.mimeType}
                        target="_blank"
                        data-testid="document_link"
                    >
                        {document.title}
                    </a>
                )
            })
            }
        </div>

    const titleComponent =
        <SectionTitle
            icon={<img className="section_title_icon" src={documentIcon} alt='document icon' />}
            title={GeneralTexts.productDocument} />

    return (
        <>
            {documentList.length > 0 &&
                <AccordionComponent
                    title={titleComponent}
                    body={componentBody}
                />}
        </>
    )
}

export default ProductDocuments
